import { 
  Code2, 
  Palette, 
  Rocket, 
  Smartphone, 
  Database, 
  Shield,
  ArrowUpRight
} from 'lucide-react'

const services = [
  {
    icon: Code2,
    title: 'Web Development',
    description: 'Custom websites and web applications built with modern technologies for optimal performance.',
    color: 'blue'
  },
  {
    icon: Palette,
    title: 'UI/UX Design',
    description: 'Beautiful, intuitive interfaces that delight users and drive engagement with your brand.',
    color: 'purple'
  },
  {
    icon: Rocket,
    title: 'Digital Marketing',
    description: 'Strategic campaigns that increase visibility and convert visitors into loyal customers.',
    color: 'orange'
  },
  {
    icon: Smartphone,
    title: 'Mobile Apps',
    description: 'Native and cross-platform mobile applications for iOS and Android devices.',
    color: 'green'
  },
  {
    icon: Database,
    title: 'Cloud Solutions',
    description: 'Scalable cloud infrastructure and database solutions for growing businesses.',
    color: 'cyan'
  },
  {
    icon: Shield,
    title: 'Cybersecurity',
    description: 'Comprehensive security audits and solutions to protect your digital assets.',
    color: 'red'
  }
]

const Services = () => {
  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Our Services</span>
          <h2 className="section-title">Solutions for Every Need</h2>
          <p className="section-subtitle">
            We offer a comprehensive suite of digital services to help your business thrive in the modern landscape.
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className={`service-card ${service.color}`}>
              <div className="service-icon">
                <service.icon size={28} />
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <a href="#contact" className="service-link">
                Learn More <ArrowUpRight size={16} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
